const url = 'https://api-cenix-management.prod.cenix.com.br/api/';

export {
    url
}